import { useContext, useEffect, useState } from "react";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import { SettingContext } from "../../routes";
import { formatDate } from "../../services/util";
import { Chart } from "react-google-charts";
import { Masonry } from "@mui/lab";
import { Card, Select, Skeleton } from "antd";
import { useParams } from "react-router-dom";
import "./TransactionDuration.css";
import { useQuery } from "react-query";
import { columnChartConfigurationOptions } from "../../config";

const { Option } = Select;

const groupByOptions = [
    { lable: "Time Range", value: 3, isDefault: true },
    { lable: "Staff", value: 1 },
    { lable: "Kiosk", value: 2 },
];
const chartOptions = {
    chart: {
        title: "Transaction Duration Graph",
        ...columnChartConfigurationOptions,
    },
};

function TransactionDuration() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { hotel_id } = useParams();
    const { selectedDates, singleSelectedHotels } = useContext(SettingContext);
    const [barChartData, setBarChartData] = useState([]);
    const [start_date, end_date] = selectedDates;

    const [formData, setFormData] = useState({
        hotel_ids: [hotel_id],
        all_selected: false,
        group_by: groupByOptions.find((e) => {
            if (e?.isDefault) return true;
        }).value,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
    });

    const {
        status: transactionDurationStatus,
        data: transactionDurationRes,
        refetch: fetchGraphData,
    } = useQuery(
        "transaction-duration-graph",
        async () => {
            return await HTTP("/dashboard/getTransactionBarChartData", {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        fetchGraphData();
    }, []);

    useEffect(() => {
        fetchGraphData();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const [, hotel_id] = singleSelectedHotels.split("#");
        setFormData({
            ...formData,
            hotel_ids: [hotel_id],
            page: 0,
            all_selected: false,
        });
    }, [singleSelectedHotels]);

    useEffect(() => {
        if (transactionDurationStatus === "success")
            setBarChartData(transactionDurationRes.data);
    }, [transactionDurationStatus, transactionDurationRes]);

    function handleSelectChange(e) {
        const updatedFormData = { ...formData, group_by: e };
        setFormData(updatedFormData);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Masonry columns={1} spacing={1}>
                <Card className="transaction-duration-graph">
                    <Select
                        id="kioskReviews"
                        className="transaction-duration-selection"
                        defaultValue={
                            groupByOptions.find((e) => {
                                if (e?.isDefault) return true;
                            }).lable
                        }
                        showSearch
                        allowClear={false}
                        onChange={handleSelectChange}
                    >
                        {groupByOptions.map((e) => (
                            <Option key={`${e.value}`}>{e.lable}</Option>
                        ))}
                    </Select>
                    {barChartData.length > 0 ? (
                        <Chart
                            width="100%"
                            height="400px"
                            chartType="ColumnChart"
                            options={{ ...chartOptions.chart }}
                            data={barChartData}
                        />
                    ) : (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 10, width: 40 }}
                        />
                    )}
                </Card>
            </Masonry>
        </Card>
    );
}

export { TransactionDuration };
